<template>
  <div class="two-factor-form">
    <form @submit.prevent="checkTwoFactorCode">
      <div>
        <div class="two-factor-title mt-x3" v-if="!is_permission_denied && !is_login_attempts_exceeded">
          2段階認証が設定されています。認証コードを入力してください。
        </div>
        <div class="two-factor-permission-denied mt-x3" v-else-if="is_permission_denied">
          2段階認証に失敗しました。認証コードが正しくありません。
        </div>
        <div class="message message-error mt-x3" v-else>
          ログインの試行に続けて失敗したため、アカウントがロックされました。数時間後に再度お試しください。
        </div>
        <div class="input-container">
          <label>認証コード</label>
          <el-input
            class="mt-x2 success"
            placeholder="認証コードを入力"
            type="text"
            v-model="code"
            tabindex="1"
          ></el-input>
        </div>
      </div>
      <div class="two-factor-action mt-x4">
        <el-button type="primary" :disabled="isDisabled" native-type="submit">認証コードを確認</el-button>
      </div>
      <div class="two-factor-action">
        <el-button @click="back"><i class="mdi mdi-arrow-left"></i>ログイン画面へ</el-button>
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.two-factor-form {
  height: auto;
}

.two-factor-title {
  color: $info-color;
  text-align: center;
}

.two-factor-permission-denied {
  color: $danger-color;
}

.two-factor-action {
  display: block;
  margin: $spacing-unit * 2 0;

  button {
    width: 100%;
  }
}

.input-container {
  width: 100%;
  margin: $spacing-unit * 2 0 0;

  label {
    font-size: $font-size;
    font-weight: bold;
  }
}
</style>
<script lang="ts">
import { defineComponent } from 'vue'

import api from '@/client/core/api'
import { PostTwoFactorAuthParams } from '@/typings/two_factor'

export default defineComponent({
  props: {
    userId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      code: '',
      is_permission_denied: false,
      is_login_attempts_exceeded: false
    }
  },
  computed: {
    isDisabled() {
      const regex = /\b\d{6}\b/g

      return this.is_login_attempts_exceeded || !this.code.trim() || !this.code.match(regex) || this.code.length !== 6
    }
  },
  methods: {
    /**
     * 認証コードを確認
     */
    async checkTwoFactorCode() {
      const params: PostTwoFactorAuthParams = {
        user_id: this.userId,
        code: this.code
      }

      this.is_permission_denied = false

      const result = await api.post('v1/two_factor/auth', params)

      if (result && result.data) {
        this.$emit('login', result.data)
        return
      }

      if (result.error && result.error.type === 'LOGIN_ATTEMPTS_EXCEEDED') {
        this.is_login_attempts_exceeded = true
        return
      }

      if (result.error && result.error.type === 'PERMISSION_DENIED') {
        this.is_permission_denied = true
        this.$notify({
          title: 'ログインに失敗しました。',
          message: '正しい認証コードを入力してください。',
          customClass: 'danger',
          duration: 10000
        })
        return
      }

      this.$notify({
        title: '2段階認証に失敗しました。',
        message: 'エラーが発生しました。恐れ入りますが時間を置いて再ログインしてください。',
        customClass: 'danger',
        duration: 10000
      })
    },

    /**
     * ログイン画面に戻す
     */
    back() {
      this.$emit('back')
    }
  }
})
</script>
